// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2681":"e4f1dda4cebc1d29","9894":"c8d1ddb46720ac38"}[chunkId] + ".js";
};